import { render, staticRenderFns } from "./dropdownType.vue?vue&type=template&id=4e452480"
import script from "./dropdownType.vue?vue&type=script&lang=js"
export * from "./dropdownType.vue?vue&type=script&lang=js"
import style0 from "./dropdownType.vue?vue&type=style&index=0&id=4e452480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports